<template>
  <ImportExport :title="$t('keywords.params')" type="parameter" :headers="headers" v-on="$listeners">
    <template #item.parameterName="{ item }">
      <v-text-field v-model="item.parameterName" style="margin-bottom: -2.3vh" outlined dense :rules="alphaNumericRules(item.parameterName)" />
    </template>

    <template #item.parameterDescription="{ item }">
      <v-text-field v-model="item.parameterDescription" style="margin-bottom: -2.3vh" outlined dense />
    </template>
  </ImportExport>
</template>

<script>
import ImportExport from '../core/ImportExport.vue'
import { alphaNumericRules } from '../../utils/rules'

export default {

  components: { ImportExport },

  data: () => ({
    alphaNumericRules
  }),

  computed: {
    headers () {
      return [
        {
          text: this.$t('parameter.param.key'),
          value: 'parameterName'
        },
        {
          text: this.$t('parameter.param.description'),
          value: 'parameterDescription'
        }
      ]
    }
  }

}
</script>
